module.exports = __webpack_public_path__ + "img/driveSafe-safetyBelts.20b5cc5.svg";